import classNames from 'classnames';
import React from 'react';

import {ShoppingItem as UdemyShoppingItem} from '@udemy/shopping';

import {Items} from './items.react-component';
import styles from './shopping-item.module.less';
import {ActionHandlers, ActionSupportedLayoutsProps, ItemTypeConfig} from './types';

export interface ItemsOfSameBuyableTypeProps {
    items: UdemyShoppingItem[];
    itemType: ItemTypeConfig;
    listName: string;
    actions: ActionHandlers;
    actionsLayout: ActionSupportedLayoutsProps;
}

export const ItemsOfSameBuyableType: React.FC<ItemsOfSameBuyableTypeProps> = ({
    items,
    itemType,
    actionsLayout,
    ...rest
}) => {
    const itemsOfBuyableType = items.filter(
        (item) => item.buyable.buyable_object_type === itemType.type,
    );

    return (
        <ul
            className={classNames(
                'ud-unstyled-list',
                styles['shopping-list-same-buyable-type-wrapper'],
            )}
        >
            {itemsOfBuyableType.map((item, i) => (
                <Items
                    key={i}
                    item={item}
                    itemType={itemType}
                    index={i}
                    actionsLayout={actionsLayout}
                    {...rest}
                />
            ))}
        </ul>
    );
};
